import styled from 'styled-components';

export const Error = styled.p`
  font-size: ${(props) => props.theme.fontSize.small};
  color: ${(props) => props.theme.colors.error};
  margin: 8px 0px 0px 0px;
`;
